module.exports = __webpack_public_path__ + "static/media/7.5191071c.jpg";